if (!customElements.get('main-product')) {
  class mainProduct extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    // product gallery
    productGallery = () => {
      var galleryThumbEle = this.querySelector('.product-thumnails .swiper');
      var galleryThumbs = new Swiper(galleryThumbEle, {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          updateOnWindowResize: true,
          navigation: {
            nextEl: '.product-thumnails [data-thumb-next]',
            prevEl: '.product-thumnails [data-thumb-prev]',
          },
          spaceBetween: 10
      });

      var galleryMainLet = this.querySelector('.product-slider .swiper');
      var galleryMain = new Swiper(galleryMainLet, {
        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        thumbs: {
          swiper: galleryThumbs
        },
        pagination: {
          el: '.swiper-pagination[data-main-product]',
          clickable: true
        }
      });

      // change slider image when variant change
      document.addEventListener('variant:change', (e) => {
        let featuredId = e.detail?.featured_media?.id;
        let currImage = this.querySelector(`.product-slider .slide-item[data-media-id="${featuredId}"]`)
        if (currImage) {
          let currentIndex = currImage.closest('.swiper-slide').dataset.index;
          galleryMain.slideTo(currentIndex);
        }
      })

      // show current media on page load
      let featuredMediaId = JSON.parse(this.querySelector('#selected_variants_json').textContent)?.featured_media?.id;
      let currentIndex = this.querySelector(`.slide-item[data-media-id="${featuredMediaId}"]`)?.closest('.swiper-slide').dataset.index;
      galleryMain.slideTo(currentIndex);

    }
    // product local pickup
    fetchLocalPickups = (data) => {
      const container = this.querySelector('[data-store-availability-container]');
      if (container) {
        fetch(window.Shopify.routes.root + `variants/${data.id}/?section_id=pickup-availability`)
          .then(response => response.text())
          .then(text => {
            const pickupAvailabilityHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section').innerHTML;
            container.innerHTML = pickupAvailabilityHTML;
            this.handlePopup();
            theme.onScrollAnimation();
          })
          .catch(e => {
            console.error(e);
          });
      }
    }

    localPickup = () => {
      document.addEventListener('variant:change', (e) => {
        this.fetchLocalPickups(e.detail);
      })
      let initialVarData = JSON.parse(this.querySelector('#selected_variants_json').textContent);
      this.fetchLocalPickups(initialVarData);
    }
    // local pickup popup
    handlePopup = () => {
      let popTrigger = this.querySelector('[data-pickup-availability-modal-open]');
      let popupTarget = this.querySelector('#PickupAvailabilityModal');
      let popCloseTrigger = this.querySelectorAll('.pickup-availabilities-modal__close,.pickup-availabilities-overlay');
      if (popTrigger) {
        popTrigger.addEventListener('click', (e) => {
          popupTarget.classList.add('open');
          popCloseTrigger[0].focus();
          document.body.classList.toggle('pickup-availability-open');
        })
      }
      if (popCloseTrigger.length > 0) {
        popCloseTrigger.forEach(closeBtn => {
          closeBtn.addEventListener('click', () => {
            popupTarget.classList.remove('open');
            popTrigger.focus();
            document.body.classList.remove('pickup-availability-open');
          })
        });
      }
    }

    // stock counter
    stockCounter = ($currVarJson) => {
      let stockCounterWrapper = this.querySelector('.stock-counter-wrapper');
      let progessEle = this.querySelector('.stock-counter-wrapper .progress-bar');
      let counterText = this.querySelector('.stock-counter-wrapper .content-wrapper');
      let currID = $currVarJson.id;
      let stockVarArray = this.querySelector('#stockQuantity');
      if (stockVarArray) {
        stockVarArray = JSON.parse(stockVarArray.textContent)
      }
      if (stockCounterWrapper) {
        let qnt = stockVarArray[currID];
        let dataLimit = parseInt(progessEle.dataset.productLimit);
        if (qnt == 0 || qnt > dataLimit) {
          stockCounterWrapper.style.display = 'none';
        } else {
          stockCounterWrapper.style = null;
          let stockMsg = counterText.dataset.text.replace('{{ count }}', qnt);
          counterText.innerHTML = stockMsg;

          progessEle.style.setProperty('--width', `${(dataLimit - (dataLimit - qnt)) / dataLimit * 100}%`)
        }
      }
    }

    // select Variant ID
    getCurrVarJSON = () => {
      let valOption1 = this.querySelector('.variant-opt-wrapper input[name="position_1"]'),
        valOption2 = this.querySelector('.variant-opt-wrapper input[name="position_2"]'),
        valOption3 = this.querySelector('.variant-opt-wrapper input[name="position_3"]');
      let varJson = JSON.parse(this.querySelector('#variants_json').textContent);
      let currVarJSON = varJson.filter(item => {
        if (item?.option1 == valOption1?.value && item?.option2 == valOption2?.value && item?.option3 == valOption3?.value) {
          return item;
        }
      })
      return currVarJSON[0];
    }

    // update price
      updatePrice = (data) => {
      let priceEle = this.querySelectorAll('.product-blocks [data-price]'),
      comparePriceEle = this.querySelector('.product-blocks [data-compare-at-price]'),
      saleBadgeEle = this.querySelector('.product-blocks [data-sale-percent]');
      let coveragePerBox = this.querySelector('.product-blocks .product-price').getAttribute('coverage-per-box');
      let price = data.price/ 100
      let comparePrice = data.compare_at_price /100
      if (priceEle) {
        priceEle.forEach(main__price => {
          main__price.textContent = window.theme.formatMoney(
            (parseFloat(price) / parseFloat(coveragePerBox)).toFixed(2),
            window.theme.money_format
          ).replace('GBP', ' / m²');
          
        })
      }
      // handle compare at price 
      if (comparePriceEle) { 
        if (comparePrice > price) {
          let salePercentage = Math.ceil((comparePrice - price) / comparePrice * 100);
          // compare price with money format
          comparePriceEle.textContent = window.theme.formatMoney(
            (parseFloat(comparePrice) / parseFloat(coveragePerBox)).toFixed(2), 
            window.theme.money_format
          ).replace('GBP', ' / m²');
          console.log("comparePriceEle",comparePriceEle)
          if (saleBadgeEle) {
            saleBadgeEle.textContent = `${salePercentage}%`;
            saleBadgeEle.style.display = null;
          }
          comparePriceEle.style.display = null;
        } else {
          comparePriceEle.style.display = 'none';
          if (saleBadgeEle) saleBadgeEle.style.display = 'none';
        }
      }
      // handle unit pricing
      let priceUnitPrice = this.querySelector('.price-unit-price');
      if (data.unit_price_measurement) {
        let referenceValue = data.unit_price_measurement.reference_value;
        let unitPriceBaseUnit = referenceValue+data.unit_price_measurement.reference_unit;
        let unitPrice = data.unit_price;

        let unitPriceEle = this.querySelector('.product-blocks [data-unit-price]');
        let unitPriceBaseUnitEle = this.querySelector('.product-blocks [data-unit-base]');

        priceUnitPrice.style.display = null;
        unitPriceEle.textContent = window.theme.formatMoney(unitPrice, window.theme.money_format);
        unitPriceBaseUnitEle.textContent = unitPriceBaseUnit;
      } else {
        priceUnitPrice.style.display = 'none';
      }
    }
    // check if variant available or not
    checkVariantAvailability = (data) => {
      let paymentBtn = this.querySelector('[data-atc-main]');
      if (paymentBtn) {
        if (data.available) {
          paymentBtn.removeAttribute('disabled');
          paymentBtn.textContent = theme.add_to_cart;
        } else {
          paymentBtn.setAttribute('disabled', 'disabled')
          paymentBtn.textContent = theme.sold_out;
        }
      }
    }
    // update variant in url
    updateVariantURL = (data) => {
      const url = new URL(location);
      url.searchParams.set("variant", data.id);
      history.replaceState({}, "", url);
    }

    // update SKU
    updateSKU = (data) => {
      let skuEle = this.querySelector('.product-sku');
      if (skuEle) {
        let skuID = data.sku;
        if (skuID) {
          skuEle.querySelector('span').textContent = skuID;
          skuEle.style.display = null;
        } else {
          skuEle.style.display = "none";
        }
      }
    }
    // shop pay installment
    shopPayInstallment = (variant) => {
      let productForm = this.querySelectorAll('.product-block:not(.block-complementary_products) form');
      productForm.forEach(form => {
        form.querySelector('[name="id"]').value = variant.id;
        form.querySelector('[name="id"]').dispatchEvent(new Event('change'));
      })
    }

    // handle variant change and get current variant data
    variantChange = () => {

      // handle click radio event
      let varRadios = this.querySelectorAll('input[data-opt-radio]');
      if (varRadios) {
        varRadios.forEach(radio => {
          radio.addEventListener('change', (e) => {
            let variantField = e.currentTarget.closest('.variant-radio-wrapper').querySelector('input[type="hidden"]');
            variantField.value = e.currentTarget.value;
            let optionLabel = e.currentTarget.closest('.variant-opt-wrapper').querySelector('.current-variant-label');
            optionLabel.innerHTML = e.currentTarget.value;
          })
        })
      }

      // trigger variant change btns
      let vartBtns = this.querySelectorAll('[data-opt-radio]');
      vartBtns.forEach(btn => {
        if (btn.tagName == 'INPUT') {
          btn.addEventListener('change', (e) => {
            document.dispatchEvent(new CustomEvent('variant:change', { 'detail': this.getCurrVarJSON() }));
          })
        } else {
          btn.addEventListener('click', (e) => {
            document.dispatchEvent(new CustomEvent('variant:change', { 'detail': this.getCurrVarJSON() }));
          })
        }
      })

      document.addEventListener('variant:change', (e) => {
        let varData = e.detail;
        this.updatePrice(varData);
        this.checkVariantAvailability(varData);
        this.updateSKU(varData);
        this.stockCounter(varData);
        this.shopPayInstallment(varData);
        if (__st.p == 'product') {
          this.updateVariantURL(varData);
        }
      })
    }

    // execute all when browser load
    PDPRefresh = () => {
      let varData = JSON.parse(this.querySelector('#selected_variants_json').textContent);
      if (varData) {
        this.updatePrice(varData);
        this.stockCounter(varData)
        this.checkVariantAvailability(varData);
        if (__st.p == 'product') {
          this.updateVariantURL(varData);
        }
      }
    }

    // recommendation products
    recommendationProducts = () => {
      // productComplementary
      let productComplementarySection = this.querySelector('[data-complementary-products]');
      if (productComplementarySection) {
        let productId = productComplementarySection.dataset.productId;
        fetch(window.Shopify.routes.root + `recommendations/products?product_id=${productId}&limit=10&section_id=complementary-products&intent=complementary`)
          .then(response => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('#product-complementary');
            if (recommendations && recommendations.innerHTML.trim().length) {
              productComplementarySection.innerHTML = recommendations.innerHTML;
            }
            theme.onScrollAnimation();
          });
      }
    }
    // handle add to cart and show drawer
    // addToCartHandle = () => {

    //   let atcBtn = this.querySelector('[data-atc-main]');
    //   console.log("atcBTn",atcBtn)
    //   if (atcBtn) {
    //     atcBtn.addEventListener('click', (e) => {
    //       e.preventDefault();
    //       e.stopPropagation();
    //       let that = e.currentTarget;
    //       let form = that.closest('form')
    //       let cartCount = document.querySelector('[data-cart-count]');
    //       fetch(theme.routes.cart_add_url, {
    //         method: 'POST',
    //         headers: {
    //           "Accept": "application/javascript",
    //           "X-Requested-With": "XMLHttpRequest"
    //         },
    //         body: new FormData(form)
    //       })
    //         .then(res => res.json())
    //         .then(res => {
    //           let lineKey = res.key;
    //           if (res.status === 422) {
    //             atcBtn.closest('form').querySelector('.error [data-error-text]').textContent = res.description;
    //             atcBtn.closest('form').querySelector('.error').style.display = 'block';
    //             setTimeout(() => {
    //               atcBtn.closest('form').querySelector('.error').style.display = 'none';
    //             }, 3000);
    //           }
    //           fetch('/cart?section_id=cart-drawer-item')
    //             .then(res => res.text())
    //             .then(body => {
    //               let drawerEle = document.querySelector('#cartDrawer');
    //               let lineItemHtml = new DOMParser().parseFromString(body, 'text/html').querySelector(`[data-line-key="${lineKey}"]`).innerHTML;
    //               document.querySelector('#cartNotificationProduct').innerHTML = lineItemHtml;
    //               drawerEle.classList.add('active');
    //               drawerEle.querySelector('button').focus();
    //               if(res.quantity == 0){
    //                 location.reload();
    //               }else{
    //                 fetch('/cart.js')
    //                 .then(res => res.json())
    //                 .then(response => {
    //                   cartCount.innerHTML = response.item_count;
    //                   if (response.item_count != 0) {
    //                     cartCount.style.display = null
    //                   } else {
    //                     cartCount.style.display = 'none'
    //                   }
    //                   theme.onScrollAnimation();
    //                 })
    //               }
    //               theme.onScrollAnimation();
    //             })
    //             theme.onScrollAnimation();
    //         })
    //     })
    //   }


    //   let drawerCloseEle = document.querySelector('#closeDrawer');
    //   if (drawerCloseEle) {
    //     drawerCloseEle.addEventListener('click', (e) => {
    //       e.currentTarget.closest('#cartDrawer').classList.remove('active');
    //       // atcBtn.focus();
    //     })
    //   }
    // }

    // init all scripts
    init = () => {
      this.PDPRefresh();
      this.productGallery();
      this.variantChange();
      this.localPickup();
      this.recommendationProducts();
      // this.addToCartHandle();
    }
  }
  customElements.define('main-product', mainProduct);
}

document.addEventListener('DOMContentLoaded', function() {
  const input = document.getElementById('entangle_floor_input');
  const totalPriceDiv = document.getElementById('efloor-price');
  const priceSpan = document.querySelector('.price__sale [data-price]');
  if(!input || !totalPriceDiv || !priceSpan)
    return;
  input.addEventListener('input', function() {
      const numericPrice = parseFloat(totalPriceDiv.textContent.split(':')[1].trim() * 100);
      priceSpan.textContent = `${window.theme.formatMoney( numericPrice, window.theme.money_format)}`;
  });
});

document.addEventListener('DOMContentLoaded',()=>
{
  document.querySelectorAll('.accordion-title').forEach(trigger => {
    let blockId = trigger.getAttribute('data-id');
      trigger.addEventListener('click', () => {
        document.querySelector(`.accordion-main[data-id="${blockId}"]`).classList.toggle('is-open');
      });
    });
    
    document.querySelectorAll('.accordion-title').forEach(trigger => {
      trigger.addEventListener('click', () => {
        trigger.classList.toggle('active');
      });
    });
})

document.addEventListener("DOMContentLoaded", async () => {
  // Get the body element to use as the target for the visualizer (full-screen)
  const targetElementVisualizer = document.getElementsByTagName('body')[0];
  console.log("targetElementVisualizer",targetElementVisualizer) 
const skuElement = document.querySelector('.product-sku span');
  const sku = skuElement ? skuElement.textContent.trim() : ''; 
  console.log('sku',sku);
  // Create a new instance of WizartVisualizer with integration settings
  const visualizer = new WizartDeploymentKit.Visualizer({
    token: 'cvgS0S7RZYrmqEwOVEidphCsfeQWCLSvaM5v854Y0kEv13xa0jvwVv3dBZ8j',
    integrationSettings: {
        openWithProduct: sku
    },
    layoutSettings: {
        targetElement: targetElementVisualizer,
        layout: WizartDeploymentKit.LAYOUTS.FULL_SCREEN,
        position: WizartDeploymentKit.POSITIONS.BEFORE
    },
});
await visualizer.load();
  
  // Get the specific div where you want to place the button
  const targetElementButton = document.getElementById('visualizer');

  // Create a button to open the visualizer
  const openVisualizerButton = WizartDeploymentKit.createButton({
      targetElement: targetElementButton, // Place the button in the 'visualizer' div
      text: "See product in your room",  // Button text
  });

  // Show the visualizer when the button is clicked
  openVisualizerButton.onClick(() => visualizer.show());
});

